<template>
	<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 10.7 14.714">
		<defs>
			<clipPath id="a"><rect width="10.7" height="14.714" fill="none"></rect></clipPath>
		</defs>
		<g clip-path="url(#a)">
			<g transform="translate(-639.169 -139.331)">
				<g transform="translate(639.169 139.331)" clip-path="url(#a)">
					<path
						d="M925.663,533.939V527.3a4.062,4.062,0,0,1,4.062-4.063h.347a4.062,4.062,0,0,1,0,8.125h-1.31v2.576Z"
						transform="translate(-923.434 -523.238)"
						fill="#c458fb"
					></path>
					<g transform="translate(0 7.03)">
						<path
							d="M926.024,540.005v2.576h-3.1V538.91a4.06,4.06,0,0,0,1.832,7.684h.348a4.062,4.062,0,0,0,4.062-4.062h0v-2.967a4.038,4.038,0,0,1-1.833.441Z"
							transform="translate(-920.695 -538.91)"
							fill="#1ccdfd"
						></path>
					</g>
					<path
						d="M928.805,532.184v2.576H927.5a4.034,4.034,0,0,0-1.833.441v3.671h3.1V536.3h1.309a4.041,4.041,0,0,0,1.833-.44v-3.671Z"
						transform="translate(-923.434 -528.171)"
						fill="#854cf9"
					></path>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'PlyLogoSVG',
};
</script>
